module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dOMWFr/tc-custom/9780857907110.jpg?1726454431623",
      "alt": "This image is the cover for the book Para Handy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Para Handy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A collection of beloved short stories starring the Scottish seaman and his quirky crew.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Master mariner Para Handy, a.k.a. Peter Macfarlane, has been sailing his way into the affections of generations of Scots since he first weighed anchor in the pages of the "), _c('i', [_vm._v("Glasgow Evening News")]), _vm._v(" in 1905. He and his crew—Dougie the mate, Macphail the Engineer, Sunny Jim, and the Tar—all play their parts in evoking the irresistible atmosphere of a bygone age when puffers sailed between West Highland ports and the great city of Glasgow."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This definitive edition contains all three collections of short stories published in the author’s lifetime, as well as those that were unpublished, and a new story that was discovered in 2001. Extensive notes accompany each story, providing fascinating insights into colloquialisms, place-names, and historical events. This volume also includes a wealth of contemporary photographs, depicting the harbors, steamers, and puffers from the age of the "), _c('i', [_vm._v("Vital Spark")]), _vm._v(".\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Neil Munro, Brian D. Osborne, Ronald Armstrong\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Neil Munro (1863 - 1930), a native of Inveraray, was a journalist by profession and for many years was the editor of the Glasgow Evening News. He is best known for his comic tales about Para Handy, but he also produced a number of historical and contemporary novels, as well as poetry and non-fiction.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Birlinn Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0